module.exports = __webpack_public_path__ + "static/img/faqs5.101daa0.png";